import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/category/importer/categoryImporterActions';

export default importerReducers(actions);
